import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon, ChevronDownIcon } from 'lucide-react';
import { AgentLiveRow } from './AgentLiveRow';
import { useDb } from '../../hooks/useDb';
import { getAgent } from '../../utils/agents';
import type { DeskStage } from '../../hooks/useDeskStage';

/** Right column: one live thread per active agent; finished threads collapse into "Klaar". */
export function AgentsAtWork({
  stage
}: {
  stage: DeskStage;
}) {
  const tasks = useDb(t => t.agentTasks);
  const pausedAgents = useDb(t => t.meta.pausedAgents);
  const [showDone, setShowDone] = useState(false);
  const active = tasks.filter(t => t.status !== 'klaar');
  const done = tasks.filter(t => t.status === 'klaar');
  return <section aria-label="Agents aan het werk" className="flex min-h-0 flex-col" data-id="element-550" data-mp="3t3p41qdvu9jl">
      <div className="flex items-baseline justify-between px-3" data-id="element-551" data-mp="3t1m2qa7a4tzk">
        <h2 className="text-[16px] font-semibold text-ink" data-id="element-552" data-mp="3o3sz9oxd2e2z">Agents aan het werk</h2>
        <span className="text-[13px] tabular-nums text-ink-muted" data-id="element-553" data-mp="49e77j2r8025">{active.length} actief</span>
      </div>
      <div role="list" className="no-scrollbar mt-2 min-h-0 flex-1 overflow-y-auto" data-id="element-554" data-mp="97o17qcqsum6">
        <AnimatePresence initial={false} data-id="element-555" data-mp="3revfa7fgsvtq">
          {active.map(t => <motion.div key={t.id} layout exit={{
          opacity: 0,
          height: 0,
          transition: {
            duration: 0.25,
            ease: [0.23, 1, 0.32, 1]
          }
        }} data-id="element-556" data-mp="80wovopv8ow">
              <AgentLiveRow task={t} paused={stage.stopped || pausedAgents.includes(t.agent)} pulseId={stage.agentPulse?.agent === t.agent ? stage.agentPulse.id : undefined} data-id="element-557" data-mp="3hmpkyr1qq2bd" />
            </motion.div>)}
        </AnimatePresence>
      </div>
      {done.length > 0 && <div className="mt-2 border-t border-white/[0.06] px-3 pt-3" data-id="element-558" data-mp="2ypennbzo5iyk">
          <button type="button" aria-expanded={showDone} onClick={() => setShowDone(v => !v)} className="flex w-full items-center gap-2 text-[14px] text-ink-soft transition-colors duration-150 hover:text-ink" data-id="element-559" data-mp="33orhwhsvdsb6">
            <CheckIcon className="h-4 w-4 text-accent" aria-hidden data-id="element-560" data-mp="14fpxyrnt1su8" />
            Klaar ({done.length})
            <ChevronDownIcon className={`ml-auto h-4 w-4 transition-transform duration-150 ${showDone ? 'rotate-180' : ''}`} aria-hidden data-id="element-561" data-mp="10e4svshiiiul" />
          </button>
          {showDone && <ul className="mt-2 space-y-1.5" data-id="element-562" data-mp="1s6lz4fe5i0e5">
              {done.map(t => {
          const a = getAgent(t.agent);
          return <li key={t.id} className="flex items-center gap-2 text-[14px]" data-id="element-563" data-mp="1j67952q8rx4b">
                    <span className="h-1.5 w-1.5 shrink-0 rounded-full" style={{
              backgroundColor: a.color
            }} aria-hidden data-id="element-564" data-mp="1e7w1mynf5yp9" />
                    <span className="text-ink-soft" data-id="element-565" data-mp="7rtpyb6fo5um">{a.name}</span>
                    <span className="truncate text-ink-muted" data-id="element-566" data-mp="2sgskwhxrgds">{t.title}</span>
                  </li>;
        })}
            </ul>}
        </div>}
    </section>;
}